export function renderExtractImportsTemplate({
  toCamelCase,
  join
}: {
  toCamelCase: string
  join: string
}): string {
  return `import type { WebhookEventSource } from '@admin/types/webhooks'

export const ${toCamelCase}WebhookEvents: WebhookEventSource = {
${join}
}
`
}
